import { render } from "./feather_icon.vue?vue&type=template&id=16fed9f6&scoped=true"
import script from "./feather_icon.vue?vue&type=script&lang=js"
export * from "./feather_icon.vue?vue&type=script&lang=js"

import "./feather_icon.vue?vue&type=style&index=0&id=16fed9f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fed9f6"]])

export default __exports__